<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("locations.code_placeholder")' :danger="$v.form.code.$invalid && $v.form.code.$model" :danger-text="$t('validation.required', { attribute: $t('locations.code') })" v-model="form.code" :label='$t("locations.code")')
      vm-col(v-if="!isSFS" vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:placeholder='$t("branches.branch_placeholder")' :danger="$v.form.branch_id.$invalid && $v.form.branch_id.$model" :danger-text="$t('validation.required', { attribute: $t('branches.branch') })" v-model="form.branch_id" :label='$t("branches.branch")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in branches")
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers, mapGetters as configMapGetters } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Locations')

export default {
  name: 'ModalLocations',
  mixins: [ModalMixin1],
  // data: () => ({}),
  validations () {
    return {
      form: {
        code: {
          required
        },
        branch_id: {
          required: requiredIf(function () {
            return !this.isSFS
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'branches']),
    ...configMapGetters(['isSFS'])
  },
  watch: {
    isModalVisible (value) {
      if (value & !this.isSFS & this.branches.length === 0) this.getBranches()
    }
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'getBranches'
    ])
  }
}
</script>
